import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';
import { ApiService } from '../../../core/services/api.service';
import { MessageService } from '../../../core/services/message.service';
import { Vehicle } from '../../../Models/vehicle';
import { DataTableComponent } from '../../../shared/data-table/data-table.component';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'vehicles',
    templateUrl: './vehicles.component.html',
    styleUrls: ['./vehicles.component.scss']
})
/** vehicles component*/
export class VehiclesComponent {

  @ViewChild("tableChild") tableChild: DataTableComponent<Vehicle>;
  pagePath: string = "api/vehicle/page";
  search: any;
  options = {
    columnTitles: ["VEHICLES.TABLE.ID", "VEHICLES.TABLE.NAME", "VEHICLES.TABLE.REGISTER_NUMBER", "VEHICLES.TABLE.COLOR", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'name', "registerNumber", "color", "actions"],
    actionButtons: { qr: true, edit: true, delete: true }
  };
  searchText: string = '';

  constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

  }

  goToEdit(e: any) {
    this.router.navigate(["vehicles/edit", e.id]);
  }

  printQR(vehicle: any){
    let params: HttpParams = new HttpParams();
    params = params.append("vehicle", vehicle.registerNumber);
    this.apiService.get('api/vehicle/printQR', params).subscribe(response => {
      if(response && response){
        this.download(response.data.document, response.data.myme, "qr", ".pdf");
      }
    });
  }

  openDeleteDialog(e: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '680px',
      data: {
        title: 'DIALOGS.DELETE_VEHICLE.TITLE',
        body: 'DIALOGS.DELETE_VEHICLE.BODY',
        cancelButtonText: "GENERAL.LABELS.CANCEL",
        confirmButtonText: "GENERAL.LABELS.DELETE",
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.delete('api/vehicle/' + e.id).subscribe(data => {
          this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "VEHICLES.MESSAGES.REMOVED");
          this.tableChild.loadPage();
        }, error => {
          this.messageService.error("Error", error.message);
        })
      }
    });
  }

  searchVeh(){
    this.search = {
      searchText: this.searchText
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
  }

  private b64toBlob(b64Data: string, contentType: string, sliceSize: number) : Blob {
    contentType = contentType || 'application/octet-stream';
    sliceSize = sliceSize || 512;
  
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
  
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      let byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
  
    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  private download(b64Data: string, contentType: string, name: string, extension: string) : void {
    
    if(b64Data.includes('base64,')) {
      b64Data = b64Data.substring(b64Data.lastIndexOf(',') + 1)
    }

    let blob = this.b64toBlob(b64Data, contentType, null);
    let blobUrl = URL.createObjectURL(blob);

      var a = document.createElement('a')
      if (typeof a.download === 'undefined') {
        window.location.assign(blobUrl);
      } else {
        a.href = blobUrl
        if (name) {
          a.download = name + '.' + extension;
        } else {
          a.download = 'evidence' + '.' + extension;
        }
        document.body.appendChild(a)
        a.click()
      }
  }
}
